import { from, of } from 'rxjs'
import { pluck, mergeMap, catchError, switchMap } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import setupActions from '../../../actions/setup'
import * as actionTypes from '../../../constants/actionTypes'

const fetchToken$ = (actions$, state$, { APIGateway }) => actions$.pipe(
  ofType(actionTypes.TOKEN_FETCH),
  pluck('payload'),
  mergeMap(({ communicationId: gigId, tokenName, options }) =>
    from(APIGateway.fetchToken(gigId, tokenName, options)).pipe(
      switchMap(tokenStream => of(setupActions.fetchTokenSuccess(tokenStream.data))),
      catchError(e => of(setupActions.fetchTokenError(e)))
    )
  )
)

export default fetchToken$
